import React from 'react';
import './Terms.css';

const Terms = () => {
  return (
    <div className="container">
      <div className="legal-page">
        <h1>Terms & Conditions</h1>
        <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using BookSummary, you accept and agree to be bound by the terms 
            and provision of this agreement.
          </p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>Permission is granted to temporarily use BookSummary for personal, non-commercial use only.</p>
          <p>This license shall automatically terminate if you violate any of these restrictions.</p>
        </section>

        <section>
          <h2>3. Premium Subscription</h2>
          <ul>
            <li>Premium subscriptions are billed monthly at $5.99/month</li>
            <li>Subscriptions automatically renew unless cancelled</li>
            <li>You may cancel your subscription at any time</li>
            <li>Refunds are provided according to our refund policy</li>
            <li>Access to premium features requires an active subscription</li>
          </ul>
        </section>

        <section>
          <h2>4. User Accounts</h2>
          <p>You are responsible for:</p>
          <ul>
            <li>Maintaining the confidentiality of your account</li>
            <li>All activities that occur under your account</li>
            <li>Providing accurate and complete information</li>
          </ul>
        </section>

        <section>
          <h2>5. Content and AI-Generated Summaries</h2>
          <p>
            Summaries generated by our AI are for informational purposes only. 
            We do not guarantee the accuracy or completeness of AI-generated content.
          </p>
        </section>

        <section>
          <h2>6. Prohibited Uses</h2>
          <p>You may not:</p>
          <ul>
            <li>Use the service for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to the service</li>
            <li>Interfere with or disrupt the service</li>
            <li>Reproduce, duplicate, or copy the service without permission</li>
          </ul>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            BookSummary shall not be liable for any indirect, incidental, special, 
            consequential, or punitive damages resulting from your use of the service.
          </p>
        </section>

        <section>
          <h2>8. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. 
            Continued use of the service after changes constitutes acceptance.
          </p>
        </section>

        <section>
          <h2>9. Contact Information</h2>
          <p>
            For questions about these Terms & Conditions, please contact us at:
            <br />
            <a href="mailto:universallythinking@gmail.com">universallythinking@gmail.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
